import { defineComponent, h } from 'vue';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import DesignerRegistryMixin from './DesignerRegistryMixin.jsx';

const BASIC_LINK_CLICK_CODE_BEHIND = {
    handlerSuffix: '_Click',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Place your click handler here\n\t}`;
    },
};

export default defineComponent({
    name: 'basic-link-dsgn',
    mixins: [DesignerRegistryMixin],
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        Root: function () {
            return this.root;
        },
        textStyles: function () {
            const styles = {};

            if (this.controlData.FontSize)
                styles['font-size'] = utils.resolveFontSize(this.controlData.FontSize);

            if (this.controlData.Color)
                styles.color = this.controlData.Color;
            else
                styles.color = 'blue';

            return styles;
        },
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedModel == this.designmodel;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, BASIC_LINK_CLICK_CODE_BEHIND);
        },
    },
    props: {
        name: '',
        root: null,
        designmodel: null,
        parentType: '',
        controlData: {}
    },
    render() {
        return (
            <div>
                <span
                    style={{ 'text-decoration': "underline", ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent), ...this.textStyles, overflow: "hidden", whiteSpace: "nowrap", display: "inline-block" }}
                    class={{ 'designer-container': true, selected: this.selected$ }}
                    onClick={(e) => this.handleClick(e)}
                    onDblclick={(e) => this.handleDesignerDblClick(e)}
                    title={this.controlData.Tooltip}>
                    <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                    {this.controlData.Text || 'Empty'}
                </span>
            </div>
        );
    }
});